import Actions from '../constants/Actions';
import { getFavorites } from './CommonActionCreators';

export async function checkAuthenticated(context) {
  console.info('Checking authentication');
  context.dispatch(Actions.AUTHENTICATION__CHECK_STARTED);
  let result = await context.service.read('authentication', {});
  if(!result) {
    return {};
  }
  console.info('Authentication check complete', result.data);
  if(!result.data.selectedClient) {
    result.data.selectedClient = {
      key: 'ignite'
    };
  }
  context.dispatch(Actions.AUTHENTICATION__CHECK_COMPLETED, result.data);

  return result.data;
}

export async function lookupActivationKey(context, { activationKey }) {
  try {
    const result = await context.service.read('password', {
      activationKey: activationKey
    });
    context.dispatch(Actions.AUTHENTICATION__ACTIVATION_KEY_FOUND, result.data);

    return result.data;
  } catch (err) {
    console.error(`Unable to find user for activationKey ${activationKey}`);
    throw err;
  }
}

export async function updateAuthenticationCredentials(context, payload) {
  context.dispatch(Actions.AUTHENTICATION__FORM_STATE_CLEARED, payload);
}

export async function forgotPassword(context, { emailAddress } = {}) {
  if (emailAddress) {
    try {
      context.dispatch(Actions.AUTHENTICATION__PASSWORD_FORGOT_STARTED);
      await context.service.delete('password', {
        emailAddress
      });

      context.dispatch(Actions.AUTHENTICATION__PASSWORD_FORGOT_COMPLETED);
    } catch (err) {
      context.dispatch(Actions.AUTHENTICATION__PASSWORD_FORGOT_FAILED, err);
    }
  }
}

export function updateResetPasswordFormState(context, formState) {
  context.dispatch(Actions.AUTHENTICATION__PASSWORD_RESET_FORM_STATE_CHANGED, formState);
}

export async function processPasswordReset(context, { password }) {
  try {
    context.dispatch(Actions.AUTHENTICATION__PASSWORD_RESET_STARTED);
    const ResetPasswordStore = context.getStore('ResetPasswordStore');
    const payload = {
      activationKey: ResetPasswordStore.getActivationKey(),
      password
    };
    await context.service.create('password', {}, payload);
    context.dispatch(Actions.AUTHENTICATION__PASSWORD_RESET_COMPLETED);
  } catch (err) {
    console.error('Error processing password reset', err);
    context.dispatch(Actions.AUTHENTICATION__PASSWORD_RESET_FAILED, err);

    throw err;
  }
}

export async function login(context, { redirect, emailAddress, password, rememberMe }) {
  context.dispatch(Actions.AUTHENTICATION__STARTED);
  const credentials = {
    emailAddress,
    password,
    rememberMe
  };


  try {
    const result = await context.service.create('authentication', {}, credentials);

    console.info('Authentication completed, dispatching event');
    if (result.data.authenticated) {
      await context.executeAction(getFavorites);
      context.dispatch(Actions.AUTHENTICATION__COMPLETED, result.data);
      console.info('Authentication event processing complete');
      const router = context.getRouter();
      if (redirect) {
        router.push(redirect);
      } else {
        router.push('/');
      }
    } else {
      context.dispatch(Actions.AUTHENTICATION__REJECTED);
    }
  } catch (err) {
    console.error(err);
    context.dispatch(Actions.AUTHENTICATION__FAILED, err);
  }
}

export async function logout(context) {
  context.dispatch(Actions.AUTHENTICATION__LOGOUT_STARTED);
  const result = await context.service.delete('authentication', {});
  context.dispatch(Actions.AUTHENTICATION__LOGOUT_COMPLETED, result.data);
}

export async function signUp(context, bank) {
  console.info('Signing up', { bank });
  context.dispatch(Actions.CLIENT_ACCOUNT__ACCOUNT_CREATION_STARTED);
  const { data: { success } } = await context.service.create('account', { bank });

  context.dispatch(Actions.CLIENT_ACCOUNT__ACCOUNT_CREATED, { success });
}



// WEBPACK FOOTER //
// ./src/actions/AuthenticationActionCreators.js